import { TextField, IconButton, Box, makeStyles } from '@material-ui/core';
import { PlusIcon, MinusIcon } from '../../../icons';

// Alias for backward compatibility
const AddIcon = PlusIcon;
const RemoveIcon = MinusIcon;

const useStyles = makeStyles({
    noSpinButtons: {
        '& input[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
            },
            '&::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
            }
        }
    }
});

function QtyNumber({
    value,
    min = 0,
    max,
    disabled,
    onChange,
    width = 56,
    sidebarButtons = false
}) {
    const classes = useStyles();
    const inputProps = { min };
    if (Number.isFinite(max)) {
        inputProps.max = max;
    }

    const currentValue = Number.isFinite(value) ? value : 0;

    const handleIncrement = () => {
        const newValue = currentValue + 1;
        if (!Number.isFinite(max) || newValue <= max) {
            onChange(newValue);
        }
    };

    const handleDecrement = () => {
        const newValue = currentValue - 1;
        if (newValue >= min) {
            onChange(newValue);
        }
    };

    if (sidebarButtons) {
        return (
            <Box display="flex" alignItems="center" gap={0.5}>
                <IconButton
                    size="small"
                    onClick={handleDecrement}
                    disabled={disabled || currentValue <= min}
                    style={{ padding: 4 }}
                >
                    <RemoveIcon fontSize="small" />
                </IconButton>
                <TextField
                    type="number"
                    value={currentValue}
                    onChange={e => onChange(parseInt(e.target.value || '0', 10))}
                    inputProps={{
                        ...inputProps,
                        style: {
                            textAlign: 'center'
                        }
                    }}
                    className={classes.noSpinButtons}
                    disabled={!!disabled}
                    style={{ width }}
                    margin="dense"
                />
                <IconButton
                    size="small"
                    onClick={handleIncrement}
                    disabled={disabled || (Number.isFinite(max) && currentValue >= max)}
                    style={{ padding: 4 }}
                >
                    <AddIcon fontSize="small" />
                </IconButton>
            </Box>
        );
    }

    return (
        <TextField
            type="number"
            value={currentValue}
            onChange={e => onChange(parseInt(e.target.value || '0', 10))}
            inputProps={inputProps}
            disabled={!!disabled}
            style={{ width }}
            margin="dense"
        />
    );
}

export default QtyNumber;
